import { defaultLang, languages } from "@excalidraw/excalidraw";
import LanguageDetector from "i18next-browser-languagedetector";

// FLF Draw: comeca em Portugues do Brasil para todo mundo. A escolha do usuario
// no menu fica guardada no navegador (chave propria, para nao herdar o "en"
// que o Excalidraw original ja tinha salvo).
const FLF_DEFAULT_LANG = "pt-BR";

export const languageDetector = new LanguageDetector();

languageDetector.init({
  languageUtils: {},
  order: ["querystring", "localStorage"],
  lookupQuerystring: "lng",
  lookupLocalStorage: "flfdraw_lng",
  caches: ["localStorage"],
});

export const getPreferredLanguage = () => {
  const detectedLanguages = languageDetector.detect();

  const detectedLanguage = Array.isArray(detectedLanguages)
    ? detectedLanguages[0]
    : detectedLanguages;

  const chosen = detectedLanguage
    ? languages.find((lang) => lang.code.startsWith(detectedLanguage))?.code
    : null;

  return (
    chosen ||
    languages.find((lang) => lang.code === FLF_DEFAULT_LANG)?.code ||
    defaultLang.code
  );
};
